const map = {
	"./opinion-analysis.json": 350,
	"./tawakkul-and-the-danger-of-looking-down-on-people.json": 98,
	"./when-speech-becomes-a-crime-how-tyranny-silences-a-nation-a-3-000-year-old-account-of-political-intimidation-still-explains-how-fear-not-force-alone-keeps-oppressive-rule-in-place-by-ustaz-abdullahi-musa.json": 320
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;